import {urlApi, urlPath, get} from '../../values/api';
const url = urlApi + urlPath.permissions

export const getData = async(token, extra="") =>{
    return await get(url, token, extra)
} 